const shorturl = {
    getlist: 'shorturl/getlist',
    add: 'shorturl/add',
    update: 'shorturl/update',
    remove: 'shorturl/remove',
    get: 'shorturl/get'
}
export default shorturl